module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app-layout', [_c('v-bloc', [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('v-quote-preview-body')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('v-panel', {
    staticClass: "panel-margin"
  }, [_c('div', {
    slot: "heading"
  }, [_c('h4', {
    staticClass: "mg-sm"
  }, [_c('span', {
    staticClass: "ion ion-person icon-sm"
  }), _vm._v("  Vastaanottajat\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._l((this.contacts), function(email) {
    return _c('div', {
      staticClass: "row nomargin"
    }, [_c('div', {
      staticClass: "col-sm-9"
    }, [_c('span', {
      staticClass: "a-btn a-block"
    }, [_vm._v(_vm._s(email))])])])
  }), _vm._v(" "), (!this.contacts.length) ? _c('div', {
    staticClass: "row nomargin"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_vm._v("Ei määriteltyjä vastaanottajia.")])])]) : _vm._e()], 2)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-sm btn-celestial-blue btn-block",
    attrs: {
      "to": {
        name: 'quote.index',
        params: {
          quoteId: _vm.$store.state.route.params.quoteId
        }
      }
    }
  }, [_vm._v("Linkki")])], 1)]), _vm._v(" "), _c('v-bloc', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('v-nav-footer', {
    attrs: {
      "type": "finish",
      "prevRoute": "inner-files.index",
      "nextRoute": "bids-open.index",
      "routeParams": {
        projectId: _vm.$store.state.route.params.projectId
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-081809ca"}!./src/app/pages/inner-preview/inner-preview.html
// module id = 457
// module chunks = 1